/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const User = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.9844 13.5845C17.9303 13.5831 19.521 15.1683 19.5225 17.1157V20.106H17.6475V17.1167L17.6387 16.9478C17.5523 16.1151 16.8401 15.4577 15.9854 15.4585H8.0127L7.84473 15.4673C7.01338 15.5545 6.35319 16.2707 6.35449 17.1265V17.1284L6.35352 20.1177L5.41602 20.1167H4.47852L4.47949 17.1274C4.47756 15.1845 6.06191 13.5867 8.00977 13.5835H15.9844V13.5845ZM12 3.88232C14.346 3.88233 16.2459 5.78273 16.2461 8.12646C16.2461 10.4708 14.3462 12.3716 12 12.3716C9.65625 12.3716 7.75586 10.4705 7.75586 8.12646C7.75603 5.78303 9.65645 3.88232 12 3.88232ZM12 5.75732C10.6922 5.75732 9.63103 6.81836 9.63086 8.12646C9.63086 9.43535 10.6922 10.4966 12 10.4966C13.3108 10.4966 14.3711 9.43505 14.3711 8.12646C14.3709 6.81867 13.3108 5.75733 12 5.75732Z"
          fill="#002967"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9268 9.56152C13.8443 9.56031 15.4126 11.1219 15.4141 13.041V15.9883H13.5654V13.042C13.5645 12.1446 12.826 11.4075 11.9277 11.4082H4.07129L3.90527 11.417C3.08606 11.5029 2.43541 12.2085 2.43652 13.0518V13.0537L2.43555 16L1.51172 15.999H0.587891L0.588867 13.0527C0.587127 11.138 2.14868 9.56347 4.06836 9.56055H11.9268V9.56152ZM8.00098 0C10.3129 5.30629e-05 12.1854 1.87285 12.1855 4.18262C12.1855 6.49287 10.313 8.36616 8.00098 8.36621C5.69132 8.36612 3.81843 6.49255 3.81836 4.18262C3.81848 1.87317 5.69145 9.53912e-05 8.00098 0ZM8.00098 1.84766C6.71217 1.84775 5.66614 2.8935 5.66602 4.18262C5.66608 5.47242 6.71224 6.51846 8.00098 6.51855C9.29272 6.5185 10.3378 5.47215 10.3379 4.18262C10.3378 2.89377 9.29279 1.84771 8.00098 1.84766Z"
        fill="#002967"
      />
    </svg>
  );
};

export default User;
